<template>
    <div class="uk-card uk-card-small uk-card-default">
      <div class="uk-card-header">
        <div class="uk-grid-small uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <div class="uk-card-title">
              {{local_page_keys.title_edit_profile}}
              <span style="background-color: #eee;padding: 2px 7px;border-radius: 10px;font-size: 14px;line-height: 1;" v-if="user.role !== null">{{ role }}</span>
            </div>
          </div>
          <div v-if="isEditableMode()">
            <progress class="uk-progress uk-width-small" :value="completionPercentage" max="100" :data-uk-tooltip="local_page_keys.profile_filled_in + ` ${completionPercentage}%`"></progress>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <div class="uk-alert uk-alert-warning uk-text-bold" data-uk-alert v-if="isEditableMode() && user.profile.needVerification">
          <a href class="uk-alert-close" data-uk-close></a>
          <div v-html="local_page_keys.alert_relevance"></div>
        </div>
        <!--Аватар-->
        <div class="uk-margin-bottom">
          <div class="uk-margin-small">
            {{local_page_keys.label_avatar}}
          </div>
          <div class="uk-grid uk-grid-small uk-child-width-1-1" data-uk-grid>
            <div class="uk-grid-small uk-grid uk-margin-small-top" data-uk-grid>
              <div class="uk-width-auto">
                <div class="uk-height-medium_ uk-position-relative" style="width: 200px;height: 200px;">
                  <div class="uk-height-1-1 tm-example-img">
                    <a class="uk-flex uk-flex-center uk-flex-middle uk-margin-remove uk-text-center uk-height-1-1" style="background-color: rgb(251 251 251);background-image: url(/img/image.svg);background-position: 50%;background-size: 80px;">
                      <img alt="" :src="user.avatar" class="">
                    </a>
                  </div>
                  <button  v-if="user.avatar" type="button" @click.prevent="deleteAvatar" :data-uk-tooltip="'title:' + local_page_keys.label_delete_photo" class="uk-position-top-right uk-button uk-button-danger uk-icon tm-light tm-light-hover" style="padding: 0 7px;border-radius: 0" title="">
                    <md-icon>delete</md-icon>
                  </button>
                </div>
              </div>
              <div class="uk-width-expand">
                <div data-uk-form-custom="target: true" class="uk-width-1-1 uk-margin-small-bottom uk-form-custom">
                  <button class="uk-button tm-button-success tm-light" style="border-radius: 0" @click.prevent="toggleShowAvatarUpload">
                    <md-icon>download</md-icon>
                  </button>
                </div>
                <div class="uk-margin-small-top uk-text-muted" style="line-height: 1.3;">
                  {{local_page_keys.label_max_size}}: 5Mb
                </div>
                <avatar-upload v-if="userLang" field="img"
                               @crop-success="cropSuccess"
                               v-model="showAvatarUpload"
                               :width=200
                               :height=200
                               :maxSize=5102
                               :noRotate="false"
                               :langType="userLang"
                               img-format="png"/>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isEditableMode()">
          <div class="uk-grid uk-grid-small uk-child-width-1-1" data-uk-grid>
            <!--Новое поле - Имя-->
            <div>
              <label>
                <div class="uk-margin-small">
                  {{local_page_keys.label_name}}*
                  <md-icon class="uk-text-success uk-margin-xsmall-left">error_outline</md-icon>
                  <div class="uk-dropdown tm-dropdown tm-dropdown-right-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: right; delay-hide: 100; delay-show: 0; offset: 10">
                    <div v-html="local_page_keys.profile_info_for_name"></div>
                  </div>
                </div>
                <div class="uk-margin-small" >
                  <input class="uk-input" v-model="user.profile.first_name" type="text" :class="{'tm-val-error': errors.first_name}">
                  <span class="text-danger" v-if="errors.first_name">{{errors.first_name}}</span>
                </div>
              </label>
            </div>
            <!--Новое поле - фамилия-->
            <div>
              <label>
                <div class="uk-margin-small">
                  {{local_page_keys.label_last_name}}*
                  <md-icon class="uk-text-success uk-margin-xsmall-left">error_outline</md-icon>
                  <div class="uk-dropdown tm-dropdown tm-dropdown-right-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: right; delay-hide: 100; delay-show: 0; offset: 10">
                    <div v-html="local_page_keys.profile_info_for_last_name"></div>
                  </div>
                </div>
                <div class="uk-margin-small">
                  <input class="uk-input" v-model="user.profile.last_name" type="text" :class="{'tm-val-error': errors.last_name}">
                  <span class="text-danger" v-if="errors.last_name">{{errors.last_name}}</span>
                </div>
              </label>
            </div>
            <!--Новое поле - Номер телефона-->
            <div>
              <label>
                <div class="uk-margin-small">
                  {{local_page_keys.label_phone_number}}*
                  <md-icon class="uk-text-success uk-margin-xsmall-left">error_outline</md-icon>
                  <div class="uk-dropdown tm-dropdown tm-dropdown-right-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: right; delay-hide: 100; delay-show: 0; offset: 10">
                    <div v-html="local_page_keys.profile_info_for_phone"></div>
                  </div>
                </div>
                <div class="uk-margin-small">
                  <input class="uk-input" v-model="user.profile.phone_number" type="text" :class="{'tm-val-error': errors.phone_number}">
                  <span class="text-danger" v-if="errors.phone_number">{{errors.phone_number}}</span>
                </div>
              </label>
            </div>
            <!--Новое поле - email-->
            <div>
              <label>
                <div class="uk-margin-small">
                  {{local_page_keys.label_email}}*
                  <md-icon class="uk-text-success uk-margin-xsmall-left">error_outline</md-icon>
                  <div class="uk-dropdown tm-dropdown tm-dropdown-right-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: right; delay-hide: 100; delay-show: 0; offset: 10">
                    <div v-html="local_page_keys.profile_info_for_email"></div>
                  </div>
                </div>
                <div class="uk-margin-small">
                  <input class="uk-input" v-model="user.profile.user_email" type="text" :class="{'tm-val-error': errors.user_email}">
                  <span class="text-danger" v-if="errors.user_email">{{errors.user_email}}</span>
                </div>
              </label>
            </div>
            <div>
              <label>
                <div class="uk-margin-small">
                  {{local_page_keys.label_login}}*
                </div>
                <div class="uk-margin-small">
                  <input class="uk-input" type="text" v-model="user.email" disabled>
                </div>
              </label>
            </div>
            <div>
              <div class="uk-grid uk-grid-small" data-uk-grid>
                <!--Новое поле - ТГ канал-->
                <div class="uk-width-expand">
                  <label>
                    <div class="uk-margin-small">
                      <!--{{ local_page_keys.table_label_telegram_id }}-->
                      Telegram ID
                      <md-icon class="uk-text-success uk-margin-xsmall-left">error_outline</md-icon>
                      <div class="uk-dropdown tm-dropdown tm-dropdown-right-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: right; delay-hide: 100; delay-show: 0; offset: 10">
                        <div v-html="local_page_keys.profile_telegram_id"></div>
                      </div>
                    </div>
                    <div class="uk-margin-small">
                      <input class="uk-input" type="text"  v-model="user.telegram_id"  disabled>
                    </div>
                  </label>
                </div>
                <!--Новое поле - подписка на ТГ боты-->
                <div class="uk-width-1-2">
                  <div class="uk-grid uk-grid-small uk-flex-middle" style="margin-top: 40px;" data-uk-grid>
                    <div>
                      {{local_page_keys.label_subscribe_to_telegram}}
                      <md-icon class="uk-text-success uk-margin-xsmall-left">error_outline</md-icon>
                      <div class="uk-dropdown tm-dropdown tm-dropdown-right-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: right; delay-hide: 100; delay-show: 0; offset: 10">
                        <div v-html="local_page_keys.profile_info_for_tg_subscription"></div>
                      </div>
                    </div>
                    <div>
                      <input class="uk-checkbox" type="checkbox" v-model="user.profile.is_subscribe_to_telegram"> {{local_page_keys.label_yes}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Новое поле - Скан/фото паспорта/ID/ДІЯ-->
            <div>
              <div class="uk-margin-small">
                {{local_page_keys.label_docs}}
                <md-icon class="uk-text-success uk-margin-xsmall-left">error_outline</md-icon>
                <div class="uk-dropdown tm-dropdown tm-dropdown-right-center" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: right; delay-hide: 100; delay-show: 0; offset: 10">
                  <div v-html="local_page_keys.profile_info_for_docs"></div>
                </div>
              </div>
              <div class="uk-grid-small uk-child-width-1-2 uk-grid uk-margin-small-top" data-uk-grid>
                  <vue-upload-multiple-image
                      @upload-success="uploadImageSuccess"
                      @before-remove="beforeRemove"
                      :data-images="imagesDoc"
                      :dragText="local_page_keys.label_drag_file"
                      browseText=""
                      :primaryText="local_page_keys.label_default"
                      :popupText="local_page_keys.label_image_default"
                      :dropText="local_page_keys.label_upload_files_here"
                      markIsPrimaryText=""
                      :showPrimary=false
                      :showEdit="false"/>
              </div>
            </div>
            <!--Новое поле - Анкета-->
            <div hidden="">
              <div class="uk-grid uk-flex-middle" data-uk-grid>
                <div>
                  <button type="button" @click.prevent="showedWorksheetModal = true" class="uk-button uk-button-success" :data-uk-tooltip="'title:' + local_page_keys.tooltip_open_form">
                    <md-icon class="uk-light uk-margin-small-right">checklist_rtl</md-icon> {{local_page_keys.button_fill_form}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div>
            <label>
              <div class="uk-margin-small">
                {{local_page_keys.label_name}}
              </div>
              <div class="uk-margin-small">
                <input class="uk-input" type="text" v-model="user.name" disabled>
              </div>
            </label>
          </div>
          <div>
            <label>
              <div class="uk-margin-small">
                {{local_page_keys.label_login}}
              </div>
              <div class="uk-margin-small">
                <input class="uk-input" type="text" v-model="user.email" disabled>
              </div>
            </label>
          </div>
          <div>
            <label>
              <div class="uk-margin-small">
                <!--{{ local_page_keys.table_label_telegram_id }}-->
                Telegram ID
              </div>
              <div class="uk-margin-small">
                <input class="uk-input" type="text"  v-model="user.telegram_id"  disabled>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div class="uk-card-footer uk-text-right uk-margin-small">
        <button @click.prevent="updateProfile" class="uk-button tm-button-success">
          {{ local_page_keys.button_update_profile }}
          <span v-if="loader" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
        </button>
      </div>
      <ModalUserWorksheetDialog
          v-if="showedWorksheetModal"
          :user="user"
          :local_page_keys="local_page_keys"
          @close="closeShowedWorksheetModal()"/>

    </div>
</template>
<script>
import ModalUserWorksheetDialog from "./../../Components/Dialogs/ModalUserWorksheetDialog";
import avatarUpload from 'vue-image-crop-upload/upload-2.vue';
import VueUploadMultipleImage from 'vue-upload-multiple-image'

export default {
  name: "edit-profile-card",
  props: {
    user: Object,
    role: String,
    userLang: String
  },
  components: {ModalUserWorksheetDialog, avatarUpload, VueUploadMultipleImage},
  data() {
    return {
      local_page_keys: {},
      showedWorksheetModal: false,
      loader: false,
      requiredFields: ['last_name', 'first_name', 'phone_number', 'user_email', 'avatar','docs'],
      errors: {
        first_name: '',
        last_name: '',
        phone_number: '',
        user_email: ''
      },
      showAvatarUpload: false,
      imgAvatar: null,
      deletedAvatar: false,
      imagesDoc: this.user.docs,
      imagesDocUpload: [],
      imagesDocDeletedIds: [],

    };
  },
  methods: {
    async updateProfile() {
      this.validateAllFields();
      if (this.hasErrors())
        return;

      this.loader = true;
      this.user.uploadAvatar = this.imgAvatar;
      this.user.deletedAvatar = this.deletedAvatar;
      this.user.imagesDocUpload = this.prepareImagesDoc();
      this.user.imagesDocDeletedIds = this.imagesDocDeletedIds;

      try {
        await this.$store.dispatch("profile/update", this.user);
        await this.$store.dispatch(
            "alerts/success",
            this.local_page_keys.alert_updated_successfully
        );

      } catch (e) {
        await this.$store.dispatch(
            "alerts/error",
            this.local_page_keys.alert_something_wrong
        );
      } finally {
        this.loader = false;
        this.imgAvatar = null;
        this.deletedAvatar = false;
        this.imagesDocUpload = null;
        this.imagesDocDeletedIds = [];
        this.$emit('getUser');
      }
    },
    validateFirstName() {
      if (this.user.profile.first_name === '') {
        this.errors.first_name = this.local_page_keys.error_first_name_required;
      } else {
        this.errors.first_name = '';
      }
    },
    validateLastName() {
      if (this.user.profile.last_name === '') {
        this.errors.last_name = this.local_page_keys.error_last_name_required;
      } else {
        this.errors.last_name = '';
      }
    },
    validatePhoneNumber() {
      const phonePattern = /^\+?[0-9]+$/;
      if (this.user.profile.phone_number === '') {
        this.errors.phone_number = this.local_page_keys.error_phone_required;
      } else if (!phonePattern.test(this.user.profile.phone_number)) {
        this.errors.phone_number = this.local_page_keys.error_phone_format;
      } else {
        this.errors.phone_number = '';
      }
    },
    validateUserEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (this.user.profile.user_email === '') {
        this.errors.user_email = this.local_page_keys.error_email_required;
      } else if (!emailPattern.test(this.user.profile.user_email)) {
        this.errors.user_email = this.local_page_keys.error_email_format;
      } else {
        this.errors.user_email = '';
      }
    },
    validateAllFields() {
      if (!this.isEditableMode())
        return;

      this.validateLastName();
      this.validateFirstName();
      this.validatePhoneNumber();
      this.validateUserEmail();
    },
    hasErrors() {
      return Object.values(this.errors).some(error => error !== '');
    },
    isEditableMode() {
      return ['retoucher', 'pro-retoucher'].indexOf(this.role) !== -1;
    },
    toggleShowAvatarUpload() {
      this.showAvatarUpload = !this.showAvatarUpload;
    },
    cropSuccess(imgDataUrl, field) {
      this.imgAvatar = imgDataUrl;
      this.user.avatar = imgDataUrl;
    },
    deleteAvatar() {
      this.user.avatar = '';
      this.deletedAvatar = true;
    },
    async closeShowedWorksheetModal() {
      this.$emit('getUser');
      this.showedWorksheetModal = false;
    },
    uploadImageSuccess(formData, index, fileList) {
      this.imagesDocUpload = fileList;
    },
    beforeRemove(index, done, fileList) {
      if (confirm(this.local_page_keys.confirm_delete_file)) {
        done()
        const fileListFormat = fileList.map(item => item.id);
        const imagesDocFormat = this.imagesDoc.map(item => item.id);
        this.imagesDocDeletedIds = imagesDocFormat.filter(item1 => !fileListFormat.some(item2 => item2 === item1));
      }
    },
    prepareImagesDoc() {
      if (!this.imagesDocUpload)
        return null;

      return this.imagesDocUpload.filter(item => {
        const path = item.path;
        // if (typeof path === 'string' && path.startsWith('data:image')){
        //   return this.base64ToImage(path)
        // }
        return typeof path === 'string' && path.startsWith('data:image');
      }).map(item => item.path);
    },
    base64ToImage(base64String) {
    var img = new Image();
     img.src = base64String;
    return img;
}
  },
  computed: {
    completionPercentage() {
      let filledCount = 0;
      for (let field of this.requiredFields) {
        if (field !== 'docs') {
          if (this.user.profile[field] || this.user[field]) {
            filledCount++;
          }
        }
      }

      if ( this.user.docs.length > 0 || this.imagesDocUpload.length > 0) {
        filledCount++;
      }

      return Math.round((filledCount / this.requiredFields.length) * 100);
    }
  },
  watch: {
    'user.profile.first_name': 'validateFirstName',
    'user.profile.last_name': 'validateLastName',
    'user.profile.phone_number': 'validatePhoneNumber',
    'user.profile.user_email': 'validateUserEmail'
  },
  async mounted() {
    this.local_page_keys = await this.$filtergetLocalisationPages(['user-edit-profile', 'user-localization']);
  }
};
</script>
<style>
@import '../../../../assets/css/uikit/progress.css';
@import '../../../../assets/css/uikit/alert.css';
.image-container {
  width: 100% !important;
  height: 250px !important;
  max-width: 100%;
}
.show-img {
  //max-height: 190px !important;
  //max-width: 100% !important;
}
.image-list-container .image-list-item .show-img {
  max-width: 50px !important;
  max-height: 50px !important;
}
.preview-image[data-v-10e59822] {
  height: 210px !important;
}
.image-list-container .image-list-item {
  height: 60px !important;
  width: 60px !important;
}
.modal-container {
  max-width: 800px;
}
.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-img-container .vicp-img {
  max-width: inherit;
}
</style>